import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  meter: {
    width: '70%',
    boxSizing: 'content-box',
    height: '20px',
    position: 'relative',
    margin: '60px 0 20px 0',
    background: '#E7E7E7',
    borderRadius: '25px',
    padding: '10px',
    boxShadow: 'inset 0 -1px 1px rgba(255, 255, 255, 0.3)',
  },

  span: (props: { baseColors: BaseColors }) => {
    return {
      display: 'block',
      height: '100%',
      borderRadius: '20px',
      backgroundColor: props.baseColors.primary,
      boxShadow: `inset 0 2px 9px rgba(255, 255, 255, 0.3),
        inset 0 -2px 6px rgba(0, 0, 0, 0.4)`,
      position: 'relative',
      overflow: 'hidden',
    }
  },
}))

export default buildStyles
